/**
 * Initial-auth availability policy. Keeps the editor bootable when the auth
 * transport is unreachable without treating authentication failures as an
 * offline session.
 */

export const INITIAL_AUTH_TIMEOUT_MS = 8000;

const LOOPBACK_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1', '[::1]']);

export function isLoopbackHostname(hostname) {
  return LOOPBACK_HOSTNAMES.has(String(hostname || '').toLowerCase());
}

/**
 * Transport failures have status 0 after authedFetch wraps them. A loopback
 * static server also answers its intentionally absent auth route with 404.
 * Real 401s and production HTTP failures must still enter the sign-in flow.
 */
export function shouldDegradeInitialAuth(error, locationLike = globalThis.location) {
  if (error?.status === 0) return true;
  return error?.status === 404 && isLoopbackHostname(locationLike?.hostname);
}
